module.exports = __webpack_public_path__ + "static/media/johnny.6a2cb8db.webp";